import { useState, useLayoutEffect } from 'react';
import { getFontScale } from 'src/common/utils/fonts';

export const useRootFontScale = () => {
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const updateSize = () => {
      setScale(getFontScale());
    };
    globalThis.addEventListener('resize', updateSize);
    updateSize();
    return () => globalThis.removeEventListener('resize', updateSize);
  }, []);

  return scale;
};
